import About from './about'

export default About
